/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AvailabilityInputs */

const en__field_availability = /** @type {(inputs: _Field_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your availability at the event`)
};

const de__field_availability = /** @type {(inputs: _Field_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Verfügbarkeit am Veranstaltungstag`)
};

/**
* | output |
* | --- |
* | "Your availability at the event" |
*
* @param {_Field_AvailabilityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_availability = /** @type {((inputs?: _Field_AvailabilityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AvailabilityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_availability(inputs)
	return de__field_availability(inputs)
});